/**
 * ChangePasswordModal — Modal "Changer mon mot de passe" (popup utilisateur connecté).
 *
 * Extrait de Layout.js (P2 refactor Feb 2026) — comportement identique.
 */
import React, { useState } from 'react';
import { LockKey } from '@phosphor-icons/react';
import { authAPI } from '../../services/api';

export default function ChangePasswordModal({ open, onClose, lang, t }) {
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [pwdMsg, setPwdMsg] = useState('');

  const reset = () => { setPwdMsg(''); setOldPwd(''); setNewPwd(''); };
  const handleClose = () => { reset(); onClose(); };

  const handleSubmit = async () => {
    try {
      await authAPI.changePassword(oldPwd, newPwd);
      setPwdMsg(lang === 'ar' ? 'تم تغيير كلمة المرور بنجاح' : 'Mot de passe modifie avec succes');
      setOldPwd('');
      setNewPwd('');
      setTimeout(() => { handleClose(); }, 1500);
    } catch (err) {
      setPwdMsg(err.response?.data?.detail || t('erreur'));
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-stone-900/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
      <div className="bg-white rounded-3xl p-8 w-full max-w-sm space-y-4 shadow-2xl">
        <h3 className="font-display text-xl font-bold text-stone-900 flex items-center gap-2">
          <LockKey size={22} className="text-sky-600" /> {t('changer_mdp')}
        </h3>
        <div>
          <label className="block text-xs font-semibold text-stone-700 mb-1.5 uppercase tracking-wider">
            {lang === 'ar' ? 'كلمة المرور القديمة' : 'Ancien mot de passe'}
          </label>
          <input
            type="password"
            value={oldPwd}
            onChange={e => setOldPwd(e.target.value)}
            className="w-full px-4 py-2.5 border border-stone-200 rounded-xl focus:ring-2 focus:ring-sky-500 focus:border-transparent outline-none"
            data-testid="change-pwd-old-input"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-stone-700 mb-1.5 uppercase tracking-wider">
            {lang === 'ar' ? 'كلمة المرور الجديدة' : 'Nouveau mot de passe'}
          </label>
          <input
            type="password"
            value={newPwd}
            onChange={e => setNewPwd(e.target.value)}
            className="w-full px-4 py-2.5 border border-stone-200 rounded-xl focus:ring-2 focus:ring-sky-500 focus:border-transparent outline-none"
            data-testid="change-pwd-new-input"
          />
        </div>
        {pwdMsg && (
          <p className={`text-sm ${pwdMsg.includes('succes') || pwdMsg.includes('نجاح') ? 'text-emerald-600' : 'text-red-500'}`}>
            {pwdMsg}
          </p>
        )}
        <div className="flex gap-2 pt-2">
          <button
            onClick={handleSubmit}
            className="flex-1 px-4 py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-xl font-semibold shadow-sm shadow-orange-500/20 transition-all active:scale-95"
            data-testid="change-pwd-submit-btn"
          >
            {t('confirmer')}
          </button>
          <button
            onClick={handleClose}
            className="flex-1 px-4 py-2.5 bg-stone-100 text-stone-700 rounded-xl hover:bg-stone-200 font-medium transition-colors"
            data-testid="change-pwd-cancel-btn"
          >
            {t('annuler')}
          </button>
        </div>
      </div>
    </div>
  );
}
